// extracted by mini-css-extract-plugin
export default {"layout":"NewInvoice_layout__rNqDo","main":"NewInvoice_main__HaGUI","aside":"NewInvoice_aside__V6dd-","page":"NewInvoice_page__PazKE","mobileBar":"NewInvoice_mobileBar__QyVF2"};